/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type ListingDetailAttributeResponseDtoGroup = typeof ListingDetailAttributeResponseDtoGroup[keyof typeof ListingDetailAttributeResponseDtoGroup];


export const ListingDetailAttributeResponseDtoGroup = {
  AVAILABLE_NETWORKS: 'AVAILABLE_NETWORKS',
  DOORS: 'DOORS',
  WALLS: 'WALLS',
  WATER: 'WATER',
  FLOORS: 'FLOORS',
  STAIRS: 'STAIRS',
  KITCHEN: 'KITCHEN',
  ROOFING: 'ROOFING',
  WINDOWS: 'WINDOWS',
  SECURITY: 'SECURITY',
  SERVICES: 'SERVICES',
  EQUIPMENT: 'EQUIPMENT',
  TRANSPORT: 'TRANSPORT',
  ACCESS_ROAD: 'ACCESS_ROAD',
  BATHROOM_WC: 'BATHROOM_WC',
  WASTEWATER: 'WASTEWATER',
  ELECTRICITY: 'ELECTRICITY',
  SURROUNDINGS: 'SURROUNDINGS',
  OBJECT_CHARACTER: 'OBJECT_CHARACTER',
  NEARBY_AMENITIES: 'NEARBY_AMENITIES',
  HEATING: 'HEATING',
  TELECOMMUNICATIONS: 'TELECOMMUNICATIONS',
  LOCATION: 'LOCATION',
  ROOF: 'ROOF',
} as const;
